var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('app-header',{attrs:{"products":_vm.products}}),_c('router-view',{attrs:{"products":_vm.products,"labels":_vm.labels}}),_c('app-footer',{attrs:{"products":_vm.products}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }